<template>
	<div class="badge">
		<Vector :src="img" class="badge-icon" />
		<div class="badge-text">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import Vector from '@/components/abstract/Vector';

export default {
	name: 'Badge',
	props: ["img"],
	components: {
		Vector,
	},
	methods: {
		completeEntrance() {
			// this.$store.commit("resetPenalty");
		},
		leaving() {
		},
	},
};
</script>

<style lang="scss" scoped>
	$badge-icon-size: 90px;

	.badge {
		display: flex;
		align-items: center;
	}

	.badge-icon {
		width: $badge-icon-size;
		height: $badge-icon-size;
		position: relative;
		z-index: 10;

		/deep/ circle {
			stroke-width: 15px;
			stroke: $brand-color-primary-dark;
		}
	}

	.badge-text {
		display: flex;
		align-items: center;
		padding: .25em 1em .25em ($badge-icon-size + 15px);

		margin-left: -$badge-icon-size;
		position: relative;
		z-index: 1;

		background: $brand-color-alt-darker;
		border-radius: 10em;

		font-size: 18px;
		font-weight: 700;
		text-align: center;
		color: $brand-color-primary-dark;
	}

</style>



// WEBPACK FOOTER //
// src/components/abstract/Badge.vue